import request from '@/utils/request'

export function getAboutUs(query) {
  return request({
    url: '/home/api/aboutUsPage',
    method: 'POST',
    params:query
  })
}